<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <oxd-grid class="orangehrm-dashboard-grid" :cols="3">
    <oxd-grid-item
      v-if="$can.read('dashboard_time_widget')"
      class="orangehrm-dashboard-widget orangehrm-dashboard-attendance-widget"
    >
      <employee-attendance-widget></employee-attendance-widget>
    </oxd-grid-item>
    <oxd-grid-item class="orangehrm-dashboard-widget">
      <quick-launch-widget></quick-launch-widget>
    </oxd-grid-item>
    <oxd-grid-item
      v-if="$can.read('dashboard_leave_widget')"
      class="orangehrm-dashboard-widget"
    >
      <employees-on-leave-widget></employees-on-leave-widget>
    </oxd-grid-item>
    <oxd-grid-item class="orangehrm-dashboard-widget">
      <my-action-summary-widget></my-action-summary-widget>
    </oxd-grid-item>
    <oxd-grid-item class="orangehrm-dashboard-widget">
      <buzz-latest-post-widget></buzz-latest-post-widget>
    </oxd-grid-item>
    <oxd-grid-item
      v-if="$can.read('dashboard_subunit_widget')"
      class="orangehrm-dashboard-widget"
    >
      <employee-subunit-widget></employee-subunit-widget>
    </oxd-grid-item>
    <oxd-grid-item
      v-if="$can.read('dashboard_location_widget')"
      class="orangehrm-dashboard-widget"
    >
      <employee-location-widget></employee-location-widget>
    </oxd-grid-item>
  </oxd-grid>
</template>

<script>
import {APIService} from '@/core/util/services/api.service';
import QuickLaunchWidget from '@/orangehrmDashboardPlugin/components/QuickLaunchWidget.vue';
import BuzzLatestPostWidget from '@/orangehrmDashboardPlugin/components/BuzzLatestPostWidget.vue';
import EmployeeSubunitWidget from '@/orangehrmDashboardPlugin/components/EmployeeSubunitWidget.vue';
import MyActionSummaryWidget from '@/orangehrmDashboardPlugin/components/MyActionSummaryWidget.vue';
import EmployeeLocationWidget from '@/orangehrmDashboardPlugin/components/EmployeeLocationWidget.vue';
import EmployeesOnLeaveWidget from '@/orangehrmDashboardPlugin/components/EmployeesOnLeaveWidget.vue';
import EmployeeAttendanceWidget from '@/orangehrmDashboardPlugin/components/EmployeeAttendanceWidget.vue';
import HeartImg from '@/orangehrmDashboardPlugin/images/heart';
import ValentineImg from '@/orangehrmDashboardPlugin/images/valentine';
import Rose83Img from '@/orangehrmDashboardPlugin/images/rose83';
import Hp83Img from '@/orangehrmDashboardPlugin/images/hp83';
import Rose2010Img from '@/orangehrmDashboardPlugin/images/rose2010';
import Hp2010Img from '@/orangehrmDashboardPlugin/images/hp2010';
import BooksImg from '@/orangehrmDashboardPlugin/images/books';
import Hp2011Img from '@/orangehrmDashboardPlugin/images/hp2011';
import TreeImg from '@/orangehrmDashboardPlugin/images/tree';
import ChristmasImg from '@/orangehrmDashboardPlugin/images/christmas';
import BirthdayCakeImg from '@/orangehrmDashboardPlugin/images/birthdayCake';
import HpbdImg from '@/orangehrmDashboardPlugin/images/hpbd';
import No1Img from '@/orangehrmDashboardPlugin/images/no1';
import OntimeImg from '@/orangehrmDashboardPlugin/images/ontime';

export default {
  components: {
    'quick-launch-widget': QuickLaunchWidget,
    'buzz-latest-post-widget': BuzzLatestPostWidget,
    'employee-subunit-widget': EmployeeSubunitWidget,
    'my-action-summary-widget': MyActionSummaryWidget,
    'employee-location-widget': EmployeeLocationWidget,
    'employees-on-leave-widget': EmployeesOnLeaveWidget,
    'employee-attendance-widget': EmployeeAttendanceWidget,
  },
  data() {
    return {
      interval: null,
      timeouts: [],
    };
  },
  created() {
    this.showCongratulations();
  },
  mounted() {
    const http = new APIService(window.appGlobal.baseUrl, 'events/push');
    http.create();
  },
  methods: {
    createIconRain(holiday) {
      const icon = document.createElement('img');
      if (holiday.isOnTime) {
        icon.src = No1Img;
      }
      if (holiday.isValentine) {
        icon.src = HeartImg;
      }
      if (holiday.is83) {
        icon.src = Rose83Img;
      }
      if (holiday.is2010) {
        icon.src = Rose2010Img;
      }
      if (holiday.is2011) {
        icon.src = BooksImg;
      }
      if (holiday.isChristmas) {
        icon.src = TreeImg;
      }
      if (holiday.isBirthday) {
        icon.src = BirthdayCakeImg;
      }
      icon.classList.add('fall-icon', 'will-delete');
      icon.style.left = `${Math.random() * 100}vw`;
      icon.style.transform = `translateY(0) rotate(${Math.random() * 360}deg)`;
      icon.style.animationDuration = `${Math.random() * 5 + 3}s`;
      icon.style.width = `${10 + Math.floor(Math.random() * 30)}px`;
      if (holiday.is2010 || holiday.is2011) {
        icon.style.width = `${30 + Math.floor(Math.random() * 50)}px`;
      }
      document.body.prepend(icon);
      setTimeout(() => {
        icon.remove();
      }, 7000);
    },
    createMainImg(holiday) {
      const mainImg = document.createElement('img');
      mainImg.classList.add('main-img', 'will-delete');
      if (holiday.isOnTime) {
        mainImg.src = OntimeImg;
        mainImg.classList.add('ontime');
      }
      if (holiday.isValentine) {
        mainImg.src = ValentineImg;
        mainImg.classList.add('valentine');
      }
      if (holiday.is83) {
        mainImg.src = Hp83Img;
        mainImg.classList.add('hp83');
      }
      if (holiday.is2010) {
        mainImg.src = Hp2010Img;
        mainImg.classList.add('hp2010');
      }
      if (holiday.is2011) {
        mainImg.src = Hp2011Img;
        mainImg.classList.add('hp2011');
      }
      if (holiday.isChristmas) {
        mainImg.src = ChristmasImg;
        mainImg.classList.add('hp2010');
      }
      if (holiday.isBirthday) {
        mainImg.src = HpbdImg;
        mainImg.classList.add('christmas');
      }
      document.body.appendChild(mainImg);
      setTimeout(() => {
        mainImg.classList.add('show');
      }, 2000);
      setTimeout(() => {
        mainImg.classList.remove('show');
        mainImg.classList.add('hide');
      }, 20000);
      setTimeout(() => {
        mainImg.remove();
      }, 21900);
    },
    addCloseButton() {
      const btn = document.createElement('button');
      btn.setAttribute('type', 'button');
      btn.innerText = 'X';
      btn.classList.add('close-button', 'will-delete');
      btn.addEventListener('click', () => {
        clearInterval(this.interval);
        const deleteItems = document.querySelectorAll('.will-delete');
        deleteItems.forEach(item => {
          item.remove();
        });
      });
      document.body.appendChild(btn);
      setTimeout(() => {
        btn.remove();
      }, 21900);
    },
    showCongratulations() {
      const mmdd = this.getMmDd();
      const hhmm = this.getHhMm();
      const showDate = localStorage.getItem('showDate');
      if (showDate === mmdd) {
        return;
      }
      localStorage.removeItem('showDate');
      const holiday = {
        isBirthday:
          window.appGlobal.userBirthday != '' &&
          mmdd == window.appGlobal.userBirthday,
        isValentine: mmdd == '0214',
        is83: mmdd == '0308',
        is2010: mmdd == '1020',
        is2011: mmdd == '1120',
        isChristmas: mmdd == '1224',
        isOnTime: '0600' <= hhmm && hhmm <= '0800',
      };
      if (
        holiday.isBirthday ||
        holiday.isValentine ||
        holiday.is83 ||
        holiday.is2010 ||
        holiday.is2011 ||
        holiday.isChristmas ||
        holiday.isOnTime
      ) {
        this.timeouts = [];
        this.interval = setInterval(this.createIconRain, 150, holiday);
        this.createMainImg(holiday);
        this.addCloseButton();
        setTimeout(() => {
          clearInterval(this.interval);
        }, 20000);
        localStorage.setItem('showDate', mmdd);
      }
    },
    getMmDd() {
      const date = new Date();
      const mm = date.getMonth() + 1;
      const dd = date.getDate();
      return `${mm > 9 ? mm : ('0' + mm)}${dd > 9 ? dd : ('0' + dd)}`;
    },
    getHhMm() {
      const date = new Date();
      const hh = date.getHours();
      const mm = date.getMinutes();
      return `${hh > 9 ? hh : ('0' + hh)}${mm > 9 ? mm : ('0' + mm)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@ohrm/oxd/styles/_mixins.scss';

.orangehrm-dashboard-grid {
  margin: 0 auto;
  box-sizing: border-box;
  max-width: calc(550px * 3);
  grid-template-columns: repeat(auto-fill, minmax(max(320px, 100%/3), 1fr));
  @media (min-width: 679px) {
    grid-template-columns: repeat(auto-fill, minmax(max(224px, 100%/3), 1fr));
  }
}
.orangehrm-dashboard-attendance-widget {
  @media (min-width: 679px) {
    grid-area: 1 / 1 / 3 / 3;
  }
}
</style>
